import Vue from 'vue';

// As a plugin
import VueMask from 'v-mask';
Vue.use(VueMask, {
  placeholders: {
    N: null // passing `null` removes default placeholder, so `N` is treated as character.
  }
});
